import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { DateTime } from 'luxon';

import Card from '../../../components/Card/Card';
import Text from '../../../components/Text/Text';

const ProfileOverview = () => {
  const {
    getMyProfile: {
      user: {
        name, last_name: lastName, login, email, created_at: createdAt
      } = {},
    }
  } = useSelector((state) => ({
    getMyProfile: state?.getMyProfile
  }), shallowEqual);

  const data = [
    {
      key: 'Full Name',
      value: `${name} ${lastName || ''}`
    },
    {
      key: 'User name',
      value: login || ''
    },
    {
      key: 'Email',
      value: email || ''
    },
    {
      key: 'Date registration',
      value: DateTime.fromISO(createdAt).toFormat('yyyy LLL dd') || ''
    },
  ];

  return (
    <div>
      <Card headerTitle="Profile Details" showHeader styleBodyContainer="p-[30px]">
        {data.map(({ key, value }) => (
          <div className="flex flex-row mb-[23px]" key={key}>
            <Text
              muted
              text={key || ''}
              textStyle="text-[#A1A5B7] text-[13px] font-medium"
              styleContainer="flex-1"
            />
            <Text text={value || ''} styleContainer="text-[14px] flex-[2]" bold />
          </div>
        ))}
      </Card>
    </div>
  );
};

export default ProfileOverview;
